import { Component, Input } from '@angular/core';

import { HugeiconsIconComponent } from '@hugeicons/angular';
import { PackageIcon } from '@hugeicons/core-free-icons';

@Component({
    selector: 'app-no-data',
    standalone: true,
    imports: [HugeiconsIconComponent],
    templateUrl: './no-data.component.html',
    styleUrl: './no-data.component.scss'
})
export class NoDataComponent {
    @Input() title: string = 'No Data Found';
    @Input() description: string = 'It seems there are no records to display at the moment.';
    @Input() icon: any = PackageIcon;
    @Input() iconSize: number = 48;
}
